import { hoursToMs } from '@mi-front/core';
import { useStreamSegmentsRange } from '../segments/useStreamSegmentsQuery';
import { useGoBackwards } from './useGoBackwards';
import { useGoForward } from './useGoForward';

/**
 * Hook to move the stream by a specified amount.
 */

export function useMoveStream() {
  const range = useStreamSegmentsRange();
  const goBackwards = useGoBackwards();
  const goForward = useGoForward();

  return (ms: number) => {
    if (ms < 0) {
      return goBackwards(-ms);
    }

    // Check if we can go forward (range.to + ms < Date.now())
    const moveAmount = ms || hoursToMs(1);
    if (range.to + moveAmount >= Date.now()) {
      return;
    }

    return goForward(ms);
  };
}
